<div class="dealer-locate modal-body-cit2" oxDrawerModal>
  <div class="row">
    <div class="col-12">
      <!-- HEADER -->
      <div class="{{language}} d-flex">
        <!-- SEARCH MODE HEADER -->
        <span class="gb-headline1" role="heading" aria-level="1" *ngIf="displayMode !== 'dealerInfo'">
          <span aria-hidden="true" class="icon-ui-search"></span>&nbsp;
          <span [translate]="'locateDealer_title'"></span>
        </span>

        <!-- DEALER INFO MODE -->
        <span class="gb-headline1" role="heading" aria-level="1" *ngIf="displayMode === 'dealerInfo'">
          <span [translate]="'preferredDealer_viewDealerInfo_title'"></span>&nbsp;
        </span>

        <button tabindex="-1" class="close-modal {{language}} ml-auto" (click)="modalRef.hide();"
                dismiss="modal" aria-hidden="false" attr.aria-label="{{'aoda_close_modal_label' | translate}}">
          <span aria-hidden="false" tabindex="0" class="icon-ui-closedot gb-body1"></span>
        </button>
      </div>
    </div>
  </div>

  <!-- SEARCH ERROR MESSAGES -->
  <div class="row">
    <div class="col-12">
      <webu-search-notifications
            [dealersTooFar]="search.dealersTooFar"
            [invalidSearch]="search.invalidSearch"
            [serverError]="search.serverError">
      </webu-search-notifications>
    </div>
  </div>

  <!-- SEARCH BAR FORM -->
  <div class="row" [hidden]="!showSearchBar">
    <webu-search-dealerships
      class="col-12 col-lg-6"
      [searchTerm]="search.term"
      [prop44]="prop44"
      [prop53]="prop53"
      [brands]="brandsLov"
      [activeVehicleMake]="vehicleMake"
      (brandSelected)="currentBrand = $event;"
      (searchChanged)="searchDealerships($event)">
    </webu-search-dealerships>
  </div>

  <!-- SEARCH RESULTS -->
  <div class="row">
    <div class="col-12">

      <!-- LOADING SPINNER -->
      <ox-loading *ngIf="search.searching"></ox-loading>

      <!-- DEALERS SEARCH RESULTS -->
      <div [hidden]="displayMode !== 'searchResults'">
        <div class="js-search-results">
          <div class="col-12">
            <!-- SEARCH RESULTS HEADER -->
            <div class="mt-10 mb-2 gb-headline2" role="heading" aria-level="2" aria-atomic="true" role="alert">
              <span [translate]="'locateDealer_dealerList_headingFirstHalf'"></span>
              {{search.dealers.length}}
              <span [translate]="'locateDealer_dealerList_headingSecondHalf'"></span>
            </div>
          </div>


          <!-- SEARCH RESULTS LIST -->
          <div class="row">
            <div class="col-12 col-md-6">

              <webu-preferred-dealer-save-notifications [status]="dealership.preferred.change.status"></webu-preferred-dealer-save-notifications>

              <div class="dealer-info-pane js-dealer-info-pane" *ngIf="!dealership.preferred.change.isShown" tabindex="-1">
                <ul class="{{language}} locate-dealer-list">

                  <!-- DEALERS LIST ITEMS -->
                  <li class="locate-dealer-list-item" *ngFor="let dealer of search.dealers">
                    <webu-dealer-list
                      [dealer]="dealer"
                      [preferredDealer]="preferredDealer"
                      [cmsPrefix]="'locateDealer'"
                      [trackLinkPrefix]="'Locate Dealer'"
                      [prop10Prefix]="'locate dealer'"
                      [isGuestMode]="isGuestMode"
                      (dealerSelected)="receiveDealer($event)"
                      (stateChange)="changeState($event)">
                    </webu-dealer-list>
                  </li>
                  <!-- END DEALER LIST ITEMS -->

                </ul>
              </div>

              <!-- CHANGE PREFERRED DEALER CONFIRMATION -->
              <div class="dealer-info-pane" *ngIf="dealership.preferred.change.isShown">
                <webu-confirm-save
                    [dealer]="dealer"
                    (dealerChange)="changeState($event)">
                </webu-confirm-save>
              </div>

              <!-- END CHANGE PREFERRED DEALER CONFIRMATION -->

            </div>
            <!-- MAP -->
            <div class="col-12 col-md-6 p-2">
              <!-- aoda_firefox_map_message cms is not defined -->
              <p class="text-center mb-1" *ngIf="isFirefox"><span class="gb-body2" [translate]="'aoda_firefox_map_message'"></span></p>
              <div class="dealer-map-canvas gray-stroke js-dealer-map-canvas"></div>
            </div>
          </div>
          <!-- END DEALER RESULTS AND MAP ROW -->
        </div>
      </div>
      <!-- END DEALERS SEARCH RESULTS -->

      <!-- VIEW DEALERSHIP INFORMATION -->
      <div *ngIf="displayMode === 'dealerInfo'">
        <div class="row">
          <div class="col-12">
            <div class="page-header-subinfo">
              <ul class="list-inline">
                <li class="gb-body1"
                    [trackLink]="'PreferredDealer:FindAnotherDealer'"
                    [trackDelay]="'true'"
                    [trackType]="'o'"
                    [prop10]="'preferred dealer:link:find another dealer'">
                    <a (click)="showSearchResults()" class="'no-href'"
                      [translate]="'preferredDealer_findAnotherDealer'">
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <webu-dealer-info
          [dealer]="dealer"
          [cmsPrefix]="'locateDealer'"
          [trackLinkPrefix]="'Locate Dealer'"
          [prop10Prefix]="'locate dealer'"
          (viewDirectionsChange)="changeState($event)">
        </webu-dealer-info>
      </div>
      <!-- END VIEW DEALERSHIP INFORMATION -->

      <!-- DIRECTIONS -->
      <div *ngIf="displayMode === 'directions'">
        <div class="col-12">
          <div class="row">
            <div class="col-6 gb-body1">
              <a class="{{language}} no-href"
                (click)="hideDirections()"
                [translate]="'locateDealer_closeDirections'">
              </a>
            </div>
          </div>
          <webu-dealer-directions [profileAddress]="profileAddress" [dealer]="dealer"></webu-dealer-directions>
        </div>
        <!-- END DIRECTIONS -->
      </div>
      <!-- END SEARCH RESULTS -->
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="modal-footer-content"></div>
</div>
